export const paymentStatus = Object.freeze({
  CREATED: { id: 0, name: 'createdPayment', color: '#8b8b8b' },
  APPROVED: { id: 2, name: 'paid', color: '#54d2a9' },
  REJECTED: { id: 3, name: 'paymentRejected', color: '#fe80af' },
  PENDING: { id: 1, name: 'pending', color: '#FEC234' },
});

export const paymentStatusTable = Object.freeze({
  CREATED: { id: 0, name: 'createdPayment', color: '#8b8b8b' },
  APPROVED: { id: 2, name: 'paid', color: '#54d2a9' },
  REJECTED: { id: 3, name: 'rejected', color: '#fe80af' },
  PENDING: { id: 1, name: 'pending', color: '#FEC234' },
});
